import { formatPoints } from '../../../../../../../../../utils/string';

export const formatAuctionPoints = (auctionPoints: number): string => {
  return auctionPoints ? formatPoints(auctionPoints) : '—';
};
